import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
export const getKeyPressHandler = (callback, keys = ['Enter', ' '], stopPropagation = false) => {
  return evt => {
    if (_includesInstanceProperty(keys).call(keys, evt.key)) {
      evt.preventDefault();
      if (stopPropagation) evt.stopPropagation();
      callback(evt);
    }
  };
};